import { type ReactNode, useMemo } from 'react';
import styled from 'styled-components';
import { StylingUtility, theme } from '../utility';

interface IPillProps {
  bgColor?: string;
  textColor?: string;
}

interface IColoredPillProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: string;
  children?: ReactNode;
  mini?: boolean;
  className?: string;
}

const Pill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 7px;
  padding: 3px 13px;
  border-radius: 15px;
  word-break: keep-all;
  width: fit-content;

  &.mini {
    font-size: 12px;
    padding: 2px 6px;
    column-gap: 4px;
  }
`;

const CustomPill = styled(Pill)<IPillProps>`
  background: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
`;

export function ColoredPill({
  color,
  children,
  mini = false,
  className = '',
  ...rest
}: IColoredPillProps) {
  const bgColor = useMemo(() => {
    if (['rgb(255,255,255)', '#FFFFFF', '#ffffff'].includes(color ?? '')) {
      return '#000000';
    }

    if (color) {
      return StylingUtility.getLowerOpacityColor(color);
    }

    return theme.colors.box;
  }, [color]);

  return (
    <CustomPill
      bgColor={bgColor}
      textColor={color}
      className={`${className} ${mini ? 'mini' : ''}`}
      {...rest}
    >
      {children}
    </CustomPill>
  );
}
